import React from 'react';
import PropTypes from 'prop-types';
import { SearchOutlined } from '@ant-design/icons';
import { AutoComplete, Button, Input } from 'antd';
import { useTableColumnSearch } from './useTableColumnSearch';

const TableColumnSearch = props => {
  const {
    searchType = '',
    valueData = '',
    isLocationCustom = false,
    showCountry = false,
    disabled = false,
    allowClear = true,
    placeholder = '',
    parentNode = null,
    inputId,
    id,
    onSearch = () => {},
    t = () => {},
  } = props;

  const { value, results, handleInput, handleSearch, handleSelect, handleScroll } =
    useTableColumnSearch(props);

  return (
    <div className="table-list__columns-dropdown">
      {searchType ? (
        <AutoComplete
          disabled={disabled}
          value={value}
          allowClear={allowClear}
          autoFocus={!isLocationCustom}
          onChange={handleSearch}
          onSelect={handleSelect}
          defaultValue={valueData}
          placeholder={placeholder}
          optionLabelProp="option"
          suffix={<SearchOutlined />}
          id={inputId}
          getPopupContainer={parentNode ? () => parentNode : null}
          onPopupScroll={handleScroll}
        >
          {results === null && (
            <AutoComplete.Option key="noResult">
              <span className="autocomplete__primary-text">
                {t('cms.message.auto_complete.no_result')}
              </span>
            </AutoComplete.Option>
          )}
          {results?.length > 0 &&
            results.map(item => {
              return (
                <AutoComplete.Option key={item.id} option={item.name}>
                  {item.name}
                  {showCountry && item.countryName && (
                    <span className="table-list__country-name">{item.countryName}</span>
                  )}
                  {showCountry && !item.published && (
                    <span className="table-list__unpublished">
                      ({t('cms.location.review.btn.unpublish')})
                    </span>
                  )}
                </AutoComplete.Option>
              );
            })}
        </AutoComplete>
      ) : (
        <div>
          <Input
            defaultValue={valueData}
            placeholder={placeholder}
            className="table-list__columns-dropdown--auto-complete"
            onChange={handleInput}
            id={id}
          />
          <Button
            onClick={() => {
              onSearch(value);
            }}
            type="primary"
            className="table-list__columns-dropdown--custom-search"
          >
            {t('cms.table.column.search.confirm')}
          </Button>
        </div>
      )}
    </div>
  );
};

TableColumnSearch.propTypes = {
  placeholder: PropTypes.string,
  searchType: PropTypes.string,
  valueData: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLocationCustom: PropTypes.bool,
  showCountry: PropTypes.bool,
  basicType: PropTypes.string,
  parentNode: PropTypes.object,
  disabled: PropTypes.bool,
  allowClear: PropTypes.bool,
  publishedStatus: PropTypes.string,
  inputId: PropTypes.string,
  id: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  changeCurrencyState: PropTypes.func,
  resetValue: PropTypes.func,
  saveSearchValue: PropTypes.func,
  onChange: PropTypes.func,
};

export default TableColumnSearch;
